import { haveAlerts, haveAll, haveTargets } from '~/src/DataType/TargetRange/utils'

import Formatter from './TargetRange'
import { formatAlerts, formatTargets } from './utils'

export default Formatter

export const formatTargetRange = dataToFormat => {
  const { annotation, entities } = dataToFormat
  const { dataTypes } = entities
  const { dataTypeKey } = annotation
  const dataType = dataTypes?.[dataTypeKey]
  const body = [
    haveTargets(annotation)
      ? formatTargets(annotation.targetMin, annotation.targetMax, dataType, !haveAll(annotation))
      : null,
    haveAlerts(annotation)
      ? formatAlerts(annotation.alertMin, annotation.alertMax, dataType)
      : null
  ].filter(Boolean).join(', ')
  return {
    body,
    title: dataType?.name || null,
    // TODO: return body key if needed
    // date: annotation.startDate ? [annotation.startDate, annotation.endDate].filter(Boolean) : null,
  }
}
